export const getMerchants = (state) =>
  Object.values(state.merchants.byId)

export const getMerchant = (state, uuid) =>
  state?.merchants?.byId[uuid] ?? {}

export const getIsMerchantsLoading = (state) =>
  state?.merchants?.isLoading ?? false

export const getMerchantsValue = (state) =>
  state?.merchants?.filters?.searchMerchantsValue ??
  ''
